import logoFallback from "@/assets/icon-logo.webp?w=160&quality=90&format=webp";
import logo from "@/assets/icon-logo.webp?w=80;160&format=webp&quality=90&as=srcset";

import BackgroundOrnaments from "@/components/background-ornaments";
// import WaitListForm from "@/components/forms/waitlist-form";
import {
  AppStoreButton,
  GooglePlayWhiteButton,
} from "@/components/store-buttons";
import useScrollAnimation from "@/hooks/use-scroll-animation";
import { DOWNLOAD_LINK } from "@/lib/constants";
import { useRef } from "react";

function Hero() {
  const logoRef = useRef<HTMLImageElement>(null);
  const logoGone = useScrollAnimation(logoRef);

  return (
    <section id="#" className="hero text-center" aria-label="Hero">
      <BackgroundOrnaments />

      <div
        className="fade-up flex-gap-md relative  z-10 container mx-auto flex w-full  
     flex-col items-center md:max-w-2xl"
      >
        {/* Logo */}
        <img
          ref={logoRef}
          id="hero-logo"
          src={logoFallback}
          srcSet={logo}
          sizes="(min-width: 640px) 58px, 46px"
          fetchPriority="high"
          alt="Sakeena Logo"
          className={`h-11.5 w-auto transition-opacity duration-300 ease-in-out sm:h-14.5 ${
            logoGone ? "opacity-0" : "opacity-100"
          }`}
        />

        <div className="flex-gap-md mx-5  flex flex-col items-center  sm:mx-3">
          <h1 className=" text-center text-5xl leading-[1.1] font-light tracking-tight text-balance sm:text-6xl md:text-8xl">
            You <span className="font-instrument italic">will</span> find
            <br />
            the one
            <br />
          </h1>

          <p className="body-text text-center">
            Sakeena is where Muslims seek marriage through personality, values, and vouches from people who know them.
          </p>
        <div className="flex-gap-md flex w-full max-w-md flex-col items-center">
          {/* <WaitListForm /> */}

          <div className="flex flex-wrap items-center justify-center gap-3">
            <AppStoreButton  href={DOWNLOAD_LINK.APP_STORE_LINK} />
            <GooglePlayWhiteButton href={DOWNLOAD_LINK.PLAY_STORE_LINK} />
          </div>

          <a
            href="#how-it-works"
            className="text-sm text-[#2b2c30] hover:underline"
          >
            See how it works
          </a>
        </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
